import React, {MouseEventHandler, ReactNode} from 'react';
import {t} from '@lingui/core/macro';

import Edit from 'shared/ui/icons/General/Edit';
import Delete from 'shared/ui/icons/General/Delete';

import MoreActionsDots from './MoreActionsDots';
import MoreActionsItem from './MoreActionsItem';

interface IEntityActionsMenuProps {
    onEdit: MouseEventHandler,
    onDelete: MouseEventHandler,
    extraActions?: ReactNode[],
    placement?: React.ComponentProps<typeof MoreActionsDots>['placement'],
}

const EntityActionsMenu: React.FC<IEntityActionsMenuProps> = ({onEdit, onDelete, extraActions = [], placement}) => (
    <MoreActionsDots placement={placement}>
        {[
            ...extraActions,
            <MoreActionsItem
                key="edit"
                label={t`Редактировать`}
                icon=<Edit/>
                onClick={onEdit}
                data-modal-trigger="true"
            />,
            <MoreActionsItem
                key="delete"
                label={t`Удалить`}
                icon=<Delete/>
                onClick={onDelete}
            />,
        ]}
    </MoreActionsDots>
);

export default React.memo(EntityActionsMenu);
